import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditTypeModel } from 'app/audit/models/audit-type.model';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-audit-type-list',
    templateUrl: './audit-type-list.component.html',
    styleUrls: ['./audit-type-list.component.css']
})
export class AuditTypeListComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    auditTypes: AuditTypeModel[];
    auditTypeList: AuditTypeModel[];
    lastSort: ColumnSortedEvent;
    filterForm: FormGroup;
    filterTextControl: FormControl;

    constructor(
        private auditService: AuditService,
        private fb: FormBuilder,
        private sortService: SortService
    ) { }

    ngOnInit() {
        this.headerTitle = { title: 'Audit Types' }
        this.auditService.getAuditTypes().subscribe(
            auditTypes => {
                this.auditTypes = auditTypes;
                this.auditTypeList = auditTypes;
            },
            error => this.errors = error.errorList
        );

        this.filterTextControl = this.fb.control('');
        this.filterForm = this.fb.group({
            filterText: this.filterTextControl
        });

        this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
            this.auditTypeList = this.sortService.filterAndSortlist(this.auditTypes, newValue, this.lastSort);
        });
    }
}
